import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import SilkTexture, { SILK } from "@/components/SilkTexture";

const SILK_BY_PAGE = [SILK.flow, SILK.ribbon, SILK.scarf];

export default function PageHeader({ eyebrow, titleLines = [], lede, rose = false, testid = "page-header", silk = 0 }) {
  return (
    <header
      data-testid={testid}
      className={`${rose ? "bg-ivory-rose" : "bg-ivory"} pt-36 sm:pt-44 pb-12 sm:pb-16 px-6 relative overflow-hidden`}
    >
      <div
        aria-hidden="true"
        className={`absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full blur-3xl ${
          rose ? "bg-rose-light/60" : "bg-rose-light/40"
        }`}
      />
      <SilkTexture src={SILK_BY_PAGE[silk % SILK_BY_PAGE.length]} side="right" opacity={0.24} speed={50} />
      <div className="max-w-5xl mx-auto relative">
        <FadeUp>
          <Eyebrow>{eyebrow}</Eyebrow>
        </FadeUp>
        <h1 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.08] tracking-tight">
          <MaskedLines lines={titleLines} immediate delay={0.1} />
        </h1>
        {lede && (
          <FadeUp delay={0.35} className="mt-7 max-w-xl text-base sm:text-lg text-ink-soft/90 font-light leading-relaxed">
            {lede}
          </FadeUp>
        )}
      </div>
    </header>
  );
}

export function LegalSection({ index, title, children }) {
  return (
    <section className="border-t border-burgundy/10 py-10 sm:py-12">
      <div className="grid sm:grid-cols-12 gap-4 sm:gap-8">
        <div className="sm:col-span-4">
          <p className="font-cinzel text-sm text-gold tracking-[0.2em]">{String(index).padStart(2, "0")}</p>
          <h2 className="mt-2 font-serif text-xl sm:text-2xl text-ink leading-snug">{title}</h2>
        </div>
        <div className="sm:col-span-8 text-[15px] font-light text-ink-soft/90 leading-relaxed space-y-4">{children}</div>
      </div>
    </section>
  );
}
